export const INVOICE_CREATED = "INVOICE_CREATED";
export const INVOICE_UPDATED = "INVOICE_UPDATED";
export const INVOICE_UPDATED_CONTENT = "INVOICE_UPDATED_CONTENT";
export const INVOICE_SENT = "INVOICE_SENT";
export const INVOICE_DISCARDED = "INVOICE_DISCARDED";
export const INVOICE_DUE_DATE_CHANGED_TO_FUTURE_DATE = "INVOICE_DUE_DATE_CHANGED_TO_FUTURE_DATE";
export const INVVOICE_DUE_DATE_CHANGED_TO_PAST_DATE = "INVVOICE_DUE_DATE_CHANGED_TO_PAST_DATE";
export const INVOICE_SNOOZED = "INVOICE_SNOOZED";
export const INVOICE_REMINDER_FEE_WRITTEN_OFF = "INVOICE_REMINDER_FEE_WRITTEN_OFF";
export const INVOICE_CREDITED = "INVOICE_CREDITED";
export const INVOICE_ASSIGNED_NEW_OWNER_MYSELF = "INVOICE_ASSIGNED_NEW_OWNER_MYSELF";
export const INVOICE_ASSIGNED_NEW_OWNER_OTHERS = "INVOICE_ASSIGNED_NEW_OWNER_OTHERS";
